import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'service.home',
    defaultMessage: 'Home',
  },
  serviceTitle: {
    id: 'service.title',
    defaultMessage: 'Service',
  },
  detailTitle: {
    id: 'service.detail.title',
    defaultMessage: 'Service Detail',
  },
  createTitle: {
    id: 'service.create',
    defaultMessage: 'Add New Service',
  },
  breadcrumbAddService: {
    id: 'service.breadcrumb.create',
    defaultMessage: 'Add New Service',
  },
  breadcrumbServiceDetail: {
    id: 'service.breadcrumb.detail',
    defaultMessage: 'Service Detail',
  },
  status: {
    active: {
      id: 'service.status.active',
      defaultMessage: 'Active',
    },
    inactive: {
      id: 'service.status.inactive',
      defaultMessage: 'Inactive',
    },
  },
  table: {
    labelNo: {
      id: 'service.table.column.no',
      defaultMessage: 'No',
    },
    serviceId: {
      id: 'service.table.column.id',
      defaultMessage: 'Service ID',
    },
    icon: {
      id: 'service.table.column.icon',
      defaultMessage: 'Icon',
    },
    serviceName: {
      id: 'service.table.column.name',
      defaultMessage: 'Service Name',
    },
    publicServiceName: {
      id: 'service.table.column.publicName',
      defaultMessage: 'Service Name in Skywalker',
    },
    category: {
      id: 'service.table.column.category',
      defaultMessage: 'Category',
    },
    aggregator: {
      id: 'service.table.column.aggregator',
      defaultMessage: 'Aggregator Name',
    },
    status: {
      id: 'service.table.column.status',
      defaultMessage: 'Status',
    },
    action: {
      id: 'service.table.column.action',
      defaultMessage: 'Action',
    },
  },
  filter: {
    prefix: {
      serviceName: {
        id: 'service.filter.prefix.serviceName',
        defaultMessage: 'Service Name is',
      },
      serviceID: {
        id: 'service.filter.prefix.serviceID',
        defaultMessage: 'Service ID is',
      },
      category: {
        id: 'service.filter.prefix.category',
        defaultMessage: 'Category is',
      },
      status: {
        id: 'service.filter.prefix.status',
        defaultMessage: 'Status is',
      },
      aggregator: {
        id: 'service.filter.prefix.aggregator',
        defaultMessage: 'Aggregator Name is',
      },
      archive: {
        id: 'service.filter.prefix.archive',
        defaultMessage: 'Show Archived',
      },
    },
    label: {
      serviceName: {
        id: 'service.filter.label.serviceName',
        defaultMessage: 'Service Name',
      },
      serviceID: {
        id: 'service.filter.label.serviceID',
        defaultMessage: 'Service ID',
      },
      category: {
        id: 'service.filter.label.category',
        defaultMessage: 'Category',
      },
      status: {
        id: 'service.filter.label.status',
        defaultMessage: 'Status',
      },
      aggregator: {
        id: 'service.filter.label.aggregator',
        defaultMessage: 'Aggregator Name',
      },
      archive: {
        id: 'service.filter.label.archive',
        defaultMessage: 'Archived',
      },
    },
  },
});
